/* eslint-disable max-lines */

import { createAction, props } from "@ngrx/store";

import { AddComplaintModel, Complaint8DNameSlimModel, ComplaintChartFilterOptions, ComplaintErrorCodeModel, ComplaintPartGroupRequest, ComplaintsModelCharts1, ComplaintsModelCharts2, ComplaintsModelCharts3, ComplaintsModelCharts4, ComplaintsModelCharts5, ComplaintsModelCharts6, ComplaintsModelCharts7, ComplaintsModelCharts8, ComplaintsModelCharts9, ComplaintsModelCharts10, ComplaintsModelCharts11, ComplaintsModelCharts12, ComplaintsModelCharts13, ComplaintsModelCharts14, ComplaintsModelCharts15, ComplaintSupplierComplaintNumberRequest, CreateComplaint8DNameRequest, DataPartAnalysisResponse, DefectivePartAnalysisSupplierResponseModel, GetAll8dNamesResponse, GetAll8dNamesSortColumn, GetAllComplaintPartGroupsResponse, GetAllComplaintPartGroupsSortColumn, GetAllComplaintsResponse, GetAllComplaintsSortColumn, GetAllComplaintSupplierComplaintNumbersResponse, GetAllComplaintSupplierComplaintNumbersSortColumn, GetComplaintErrorCodesResponse, GetComplaintErrorCodesSortColumn, GetImportHistorySortColumn, ImportHistoryResponse, SortDirectionType, SourceType, UpdateComplaint8DNameRequest } from "../../../shared/generated";

export const getAllComplaints = createAction(
  '[Parts] GET_ALL_COMPLAINTS',
  props<{ sources?: string[], partGroups?: string[], shipmentNumber?: string, shipmentDateFrom?: string, shipmentDateTo?: string, supplierNumbers?: string[], partIdentNumber?: string, defectivePartNumber?: string, supplierDecisions?: string[], statusPartAnalysis?: string[], statusClientResponses?: string[], warrantyCenters?: string[], supplierComplaintNumbers?: string[], index?: number, size?: number, sortColumn?: GetAllComplaintsSortColumn, sortDirectionType?: SortDirectionType }>()
);
export const getAllComplaintsSuccess = createAction(
  '[Parts] GET_ALL_COMPLAINTS_SUCCESS',
  props<{ complaints: GetAllComplaintsResponse }>()
);
export const getAllComplaintsError = createAction(
  '[Parts] GET_ALL_COMPLAINTS_ERROR',
  props<{ payload: any }>()
);

export const getAllComplaintsByAdmin = createAction(
  '[Parts] GET_ALL_COMPLAINTS_BY_ADMIN',
  props<{ sources?: string[], partGroups?: string[], shipmentNumber?: string, shipmentDateFrom?: string, shipmentDateTo?: string, supplierNumbers?: string[], partIdentNumber?: string, defectivePartNumber?: string, supplierDecisions?: string[], statusPartAnalysis?: string[], statusClientResponses?: string[], warrantyCenters?: string[], supplierComplaintNumbers?: string[], index?: number, size?: number, sortColumn?: GetAllComplaintsSortColumn, sortDirectionType?: SortDirectionType }>()
);
export const getAllComplaintsByAdminSuccess = createAction(
  '[Parts] GET_ALL_COMPLAINTS_BY_ADMIN_SUCCESS',
  props<{ complaints: GetAllComplaintsResponse }>()
);
export const getAllComplaintsByAdminError = createAction(
  '[Parts] GET_ALL_COMPLAINTS_BY_ADMIN_ERROR',
  props<{ payload: any }>()
);

export const createComplaint = createAction(
  '[Parts] CREATE_COMPLAINT',
  props<{ addComplaintModel: AddComplaintModel, }>()
);
export const createComplaintSuccess = createAction(
  '[Parts] CREATE_COMPLAINT_SUCCESS'
);
export const createComplaintError = createAction(
  '[Parts] CREATE_COMPLAINT_ERROR',
  props<{ payload: any }>()
);

export const getAllPartGroups = createAction(
  '[Parts] GET_ALL_PRODUCT_GROUPS',
  props<{ sources?: string[], partGroup?: string, clientPartNumber?: string, warrantyCenter?: string, supplierPartNumber?: string, index: number, size: number, sortColumn?: GetAllComplaintPartGroupsSortColumn, sortDirectionType?: SortDirectionType }>()
);
export const getAllPartGroupsSuccess = createAction(
  '[Parts] GET_ALL_PRODUCT_GROUPS_SUCCESS',
  props<{ partGroups: GetAllComplaintPartGroupsResponse }>()
);
export const getAllPartGroupsError = createAction(
  '[Parts] GET_ALL_PRODUCT_GROUPS_ERROR',
  props<{ payload: any }>()
);

export const getAllSupplierComplaintNumbers = createAction(
  '[Parts] GET_ALL_SUPPLIER_COMPLAINT_NUMBER',
  props<{ sources?: string[], partIdentNumber?: string, supplierComplaintNumber?: string, shipmentNumber?: string, index: number, size: number, sortColumn?: GetAllComplaintSupplierComplaintNumbersSortColumn, sortDirectionType?: SortDirectionType }>()
);
export const getAllSupplierComplaintNumbersSuccess = createAction(
  '[Parts] GET_ALL_SUPPLIER_COMPLAINT_NUMBER_SUCCESS',
  props<{ complaintSupplierComplaintNumbers: GetAllComplaintSupplierComplaintNumbersResponse }>()
);
export const getAllSupplierComplaintNumbersError = createAction(
  '[Parts] GET_ALL_SUPPLIER_COMPLAINT_NUMBER_ERROR',
  props<{ payload: any }>()
);

export const getAllErrorCodes = createAction(
  '[Parts] GET_ALL_ERROR_CODES',
  props<{ sources?: string[], errorCode?: string, errorCodeName?: string, index: number, size: number, sortColumn?: GetComplaintErrorCodesSortColumn, sortDirectionType?: SortDirectionType }>()
);
export const getAllErrorCodesSuccess = createAction(
  '[Parts] GET_ALL_ERROR_CODES_SUCCESS',
  props<{ errorCodes: GetComplaintErrorCodesResponse }>()
);
export const getAllErrorCodesError = createAction(
  '[Parts] GET_ALL_ERROR_CODES_ERROR',
  props<{ payload: any }>()
);

export const put8DName = createAction(
  '[Parts] PUT_8D_NAME',
  props<{ id: number, updateComplaint8DNameRequest?: UpdateComplaint8DNameRequest }>()
);
export const put8DNameSuccess = createAction(
  '[Parts] PUT_8D_NAME_SUCCESS'
);
export const put8DNameError = createAction(
  '[Parts] PUT_8D_NAME_ERROR',
  props<{ payload: any }>()
);

export const putPartGroup = createAction(
  '[Parts] PUT_PRODUCT_GROUP',
  props<{ id: number, complaintPartGroupRequest?: ComplaintPartGroupRequest }>()
);
export const putPartGroupSuccess = createAction(
  '[Parts] PUT_PRODUCT_GROUP_SUCCESS'
);
export const putPartGroupError = createAction(
  '[Parts] PUT_PRODUCT_GROUP_ERROR',
  props<{ payload: any }>()
);

export const putComplaintSupplierComplaintNumber = createAction(
  '[Parts] PUT_COMPLAINT_SUPPLIER_COMPLAINT_NUMBER',
  props<{ id: number, complaintSupplierComplaintNumberRequest?: ComplaintSupplierComplaintNumberRequest }>()
);
export const putComplaintSupplierComplaintNumberSuccess = createAction(
  '[Parts] PUT_COMPLAINT_SUPPLIER_COMPLAINT_NUMBER_SUCCESS'
);
export const putComplaintSupplierComplaintNumberError = createAction(
  '[Parts] PUT_COMPLAINT_SUPPLIER_COMPLAINT_NUMBER_ERROR',
  props<{ payload: any }>()
);

export const putErrorCode = createAction(
  '[Parts] PUT_ERROR_CODE',
  props<{ errorCode: string, source: string, errorLabelGerman: string, errorDescriptionGerman: string, errorLabelEnglish: string, errorDescriptionEnglish: string, id: number, errorCodeName?: string, isActive?: boolean }>()
);
export const putErrorCodeSuccess = createAction(
  '[Parts] PUT_ERROR_CODE_SUCCESS'
);
export const putErrorCodeError = createAction(
  '[Parts] PUT_ERROR_CODE_ERROR',
  props<{ payload: any }>()
);

export const getAll8dNames = createAction(
  '[Parts] GET_ALL_8D_NAMES',
  props<{ sources?: string[], name?: string, clientProblemCode8D?: string, supplierProblemCode8D?: string, index: number, size: number, sortColumn?: GetAll8dNamesSortColumn, sortDirectionType?: SortDirectionType }>()
);
export const getAll8dNamesSuccess = createAction(
  '[Parts] GET_ALL_8D_NAMES_SUCCESS',
  props<{ eightDNames: GetAll8dNamesResponse }>()
);
export const getAll8dNamesError = createAction(
  '[Parts] GET_ALL_8D_NAMES_ERROR',
  props<{ payload: any }>()
);

export const getDownloadComplaintsAsCsv = createAction(
  '[Parts] GET_DOWNLOAD_COMPLAINTS_AS_CSV',
  props<{ sources?: string[], partGroups?: string[], shipmentNumber?: string, shipmentDateFrom?: string, shipmentDateTo?: string, supplierNumbers?: string[], partIdentNumber?: string, defectivePartNumber?: string, supplierDecisions?: string[], statusPartAnalysis?: string[], statusClientResponses?: string[], warrantyCenters?: string[], supplierComplaintNumbers?: string[], sortColumn?: GetAllComplaintsSortColumn, sortDirectionType?: SortDirectionType }>()
);
export const getDownloadComplaintsAsCsvSuccess = createAction(
  '[Parts] GET_DOWNLOAD_COMPLAINTS_AS_CSV_SUCCESS',
  props<{ csvFile: any }>()
);
export const getDownloadComplaintsAsCsvError = createAction(
  '[Parts] GET_DOWNLOAD_COMPLAINTS_AS_CSV_ERROR',
  props<{ payload: any }>()
);

export const getDownloadComplaintsAsExcel = createAction(
  '[Parts] GET_DOWNLOAD_COMPLAINTS_AS_EXCEL',
  props<{ sources?: string[], partGroups?: string[], shipmentNumber?: string, shipmentDateFrom?: string, shipmentDateTo?: string, supplierNumbers?: string[], partIdentNumber?: string, defectivePartNumber?: string, supplierDecisions?: string[], statusPartAnalysis?: string[], statusClientResponses?: string[], warrantyCenters?: string[], supplierComplaintNumbers?: string[], sortColumn?: GetAllComplaintsSortColumn, sortDirectionType?: SortDirectionType }>()
);
export const getDownloadComplaintsAsExcelSuccess = createAction(
  '[Parts] GET_DOWNLOAD_COMPLAINTS_AS_EXCEL_SUCCESS',
  props<{ excelFile: any }>()
);
export const getDownloadComplaintsAsExcelError = createAction(
  '[Parts] GET_DOWNLOAD_COMPLAINTS_AS_EXCEL_ERROR',
  props<{ payload: any }>()
);

export const getAllComplaintTableFilterOptions = createAction(
  '[Parts] GET_ALL_COMPLAINT_TABLE_FILTER_OPTIONS'
);
export const getAllComplaintTableFilterOptionsSuccess = createAction(
  '[Parts] GET_ALL_COMPLAINT_TABLE_FILTER_OPTIONS_SUCCESS',
  props<{ complaintTableFilterOptions: ComplaintChartFilterOptions[] }>()
);
export const getAllComplaintTableFilterOptionsError = createAction(
  '[Parts] GET_ALL_COMPLAINT_TABLE_FILTER_OPTIONS_ERROR',
  props<{ payload: any }>()
);

export const getAllSources = createAction(
  '[Parts] GET_ALL_SOURCES',
);
export const getAllSourcesSuccess = createAction(
  '[Parts] GET_ALL_SOURCES_SUCCESS',
  props<{ sources: any[] }>()
);
export const getAllSourcesError = createAction(
  '[Parts] GET_ALL_SOURCES_ERROR',
  props<{ payload: any }>()
);

export const getAllComplaintChartFilterOptions = createAction(
  '[Parts] GET_ALL_COMPLAINT_CHART_FILTER_OPTIONS'
);
export const getAllComplaintChartFilterOptionsSuccess = createAction(
  '[Parts] GET_ALL_COMPLAINT_CHART_FILTER_OPTIONS_SUCCESS',
  props<{ complaintChartFilterOptions: ComplaintChartFilterOptions[] }>()
);
export const getAllComplaintChartFilterOptionsError = createAction(
  '[Parts] GET_ALL_COMPLAINT_CHART_FILTER_OPTIONS_ERROR',
  props<{ payload: any }>()
);

export const deleteComplaint = createAction(
  '[Parts] DELETE_COMPLAINT',
  props<{ complainId: number, hashValue?: string }>()
);
export const deleteComplaintSuccess = createAction(
  '[Parts] DELETE_COMPLAINT_SUCCESS',
);
export const deleteComplaintError = createAction(
  '[Parts] DELETE_COMPLAINT_ERROR',
  props<{ payload: number }>()
);

export const restoreComplaint = createAction(
  '[Parts] RESTORE_COMPLAINT',
  props<{ complainId: number }>()
);
export const restoreComplaintSuccess = createAction(
  '[Parts] RESTORE_COMPLAINT_SUCCESS',
);
export const restoreComplaintError = createAction(
  '[Parts] RESTORE_COMPLAINT_ERROR',
  props<{ payload: number }>()
);

export const postReadDataFromPorschePdf = createAction(
  '[Parts] POST_READ_DATA_FROM_PORSCHE_PDF',
  props<{ file: Blob }>()
);
export const postReadDataFromPorschePdfSuccess = createAction(
  '[Parts] POST_READ_DATA_FROM_PORSCHE_PDF_SUCCESS'
);
export const postReadDataFromPorschePdfError = createAction(
  '[Parts] POST_READ_DATA_FROM_PORSCHE_PDF_ERROR',
  props<{ payload: number }>()
);

export const getJsonForPartIdentNumber = createAction(
  '[Parts] GET_JSON_FOR_PART_IDENT_NUMBER',
  props<{ partIdentNumber: string }>()
);
export const getJsonForPartIdentNumberSuccess = createAction(
  '[Parts] GET_JSON_FOR_PART_IDENT_NUMBER_SUCCESS',
  props<{ complaintsDetails: any }>()
);
export const getJsonForPartIdentNumberError = createAction(
  '[Parts] GET_JSON_FOR_PART_IDENT_NUMBER_ERROR',
  props<{ payload: any }>()
);

export const getChartCustomerDecisionPerShipmentYear = createAction(
  '[Parts] GET_CHART_CUSTOMER_DECISION_PER_SHIPMENT_YEAR',
  props<{ sources?: Array<string>, supplierNumbers?: Array<string>, partGroups?: Array<string>, returnCountries?: Array<string>, shipmentDateFrom?: string, shipmentDateTo?: string }>()
);
export const getChartCustomerDecisionPerShipmentYearSuccess = createAction(
  '[Parts] GET_CHART_CUSTOMER_DECISION_PER_SHIPMENT_YEAR_SUCCESS',
  props<{ chartData: ComplaintsModelCharts1[] }>()
);
export const getChartCustomerDecisionPerShipmentYearError = createAction(
  '[Parts] GET_CHART_CUSTOMER_DECISION_PER_SHIPMENT_YEAR_ERROR',
  props<{ payload: any }>()
);

export const getChartCustomerDecisionPerShipmentMonth = createAction(
  '[Parts] GET_CHART_CUSTOMER_DECISION_PER_SHIPMENT_MONTH',
  props<{ sources?: Array<string>, supplierNumbers?: Array<string>, partGroups?: Array<string>, returnCountries?: Array<string>, shipmentDateFrom?: string, shipmentDateTo?: string }>()
);
export const getChartCustomerDecisionPerShipmentMonthSuccess = createAction(
  '[Parts] GET_CHART_CUSTOMER_DECISION_PER_SHIPMENT_MONTH_SUCCESS',
  props<{ chartData: ComplaintsModelCharts2[] }>()
);
export const getChartCustomerDecisionPerShipmentMonthError = createAction(
  '[Parts] GET_CHART_CUSTOMER_DECISION_PER_SHIPMENT_MONTH_ERROR',
  props<{ payload: any }>()
);

export const getChartSupplierFeedbackPerShipmentYear = createAction(
  '[Parts] GET_CHART_SUPPLIER_FEEDBACK_PER_SHIPMENT_YEAR',
  props<{ sources?: Array<string>, supplierNumbers?: Array<string>, partGroups?: Array<string>, returnCountries?: Array<string>, shipmentDateFrom?: string, shipmentDateTo?: string }>()
);
export const getChartSupplierFeedbackPerShipmentYearSuccess = createAction(
  '[Parts] GET_CHART_SUPPLIER_FEEDBACK_PER_SHIPMENT_YEAR_SUCCESS',
  props<{ chartData: ComplaintsModelCharts3[] }>()
);
export const getChartSupplierFeedbackPerShipmentYearError = createAction(
  '[Parts] GET_CHART_SUPPLIER_FEEDBACK_PER_SHIPMENT_YEAR_ERROR',
  props<{ payload: any }>()
);

export const getChartSupplierFeedbackPerShipmentMonth = createAction(
  '[Parts] GET_CHART_SUPPLIER_FEEDBACK_PER_SHIPMENT_MONTH',
  props<{ sources?: Array<string>, supplierNumbers?: Array<string>, partGroups?: Array<string>, returnCountries?: Array<string>, shipmentDateFrom?: string, shipmentDateTo?: string }>()
);
export const getChartSupplierFeedbackPerShipmentMonthSuccess = createAction(
  '[Parts] GET_CHART_SUPPLIER_FEEDBACK_PER_SHIPMENT_MONTH_SUCCESS',
  props<{ chartData: ComplaintsModelCharts4[] }>()
);
export const getChartSupplierFeedbackPerShipmentMonthError = createAction(
  '[Parts] GET_CHART_SUPPLIER_FEEDBACK_PER_SHIPMENT_MONTH_ERROR',
  props<{ payload: any }>()
);

export const getChartSupplierFeedbackPerRepairYear = createAction(
  '[Parts] GET_CHART_SUPPLIER_FEEDBACK_PER_REPAIR_YEAR',
  props<{ sources?: Array<string>, supplierNumbers?: Array<string>, partGroups?: Array<string>, returnCountries?: Array<string>, repairDateFrom?: string, repairDateTo?: string }>()
);
export const getChartSupplierFeedbackPerRepairYearSuccess = createAction(
  '[Parts] GET_CHART_SUPPLIER_FEEDBACK_PER_REPAIR_YEAR_SUCCESS',
  props<{ chartData: ComplaintsModelCharts5[] }>()
);
export const getChartSupplierFeedbackPerRepairYearError = createAction(
  '[Parts] GET_CHART_SUPPLIER_FEEDBACK_PER_REPAIR_YEAR_ERROR',
  props<{ payload: any }>()
);

export const getChartSupplierFeedbackPerRepairMonth = createAction(
  '[Parts] GET_CHART_SUPPLIER_FEEDBACK_PER_REPAIR_MONTH',
  props<{ sources?: Array<string>, supplierNumbers?: Array<string>, partGroups?: Array<string>, returnCountries?: Array<string>, repairDateFrom?: string, repairDateTo?: string }>()
);
export const getChartSupplierFeedbackPerRepairMonthSuccess = createAction(
  '[Parts] GET_CHART_SUPPLIER_FEEDBACK_PER_REPAIR_MONTH_SUCCESS',
  props<{ chartData: ComplaintsModelCharts6[] }>()
);
export const getChartSupplierFeedbackPerRepairMonthError = createAction(
  '[Parts] GET_CHART_SUPPLIER_FEEDBACK_PER_REPAIR_MONTH_ERROR',
  props<{ payload: any }>()
);

export const getChartSupplierFeedbackPerPartProductionYear = createAction(
  '[Parts] GET_CHART_SUPPLIER_FEEDBACK_PER_PART_PRODUCTION_YEAR',
  props<{ sources?: Array<string>, supplierNumbers?: Array<string>, partGroups?: Array<string>, returnCountries?: Array<string>, partProductionDateFrom?: string, partProductionDateTo?: string }>()
);
export const getChartSupplierFeedbackPerPartProductionYearSuccess = createAction(
  '[Parts] GET_CHART_SUPPLIER_FEEDBACK_PER_PART_PRODUCTION_YEAR_SUCCESS',
  props<{ chartData: ComplaintsModelCharts7[] }>()
);
export const getChartSupplierFeedbackPerPartProductionYearError = createAction(
  '[Parts] GET_CHART_SUPPLIER_FEEDBACK_PER_PART_PRODUCTION_YEAR_ERROR',
  props<{ payload: any }>()
);

export const getChartSupplierFeedbackPerPartProductionMonth = createAction(
  '[Parts] GET_CHART_SUPPLIER_FEEDBACK_PER_PART_PRODUCTION_MONTH',
  props<{ sources?: Array<string>, supplierNumbers?: Array<string>, partGroups?: Array<string>, returnCountries?: Array<string>, partProductionDateFrom?: string, partProductionDateTo?: string }>()
);
export const getChartSupplierFeedbackPerPartProductionMonthSuccess = createAction(
  '[Parts] GET_CHART_SUPPLIER_FEEDBACK_PER_PART_PRODUCTION_MONTH_SUCCESS',
  props<{ chartData: ComplaintsModelCharts8[] }>()
);
export const getChartSupplierFeedbackPerPartProductionMonthError = createAction(
  '[Parts] GET_CHART_SUPPLIER_FEEDBACK_PER_PART_PRODUCTION_MONTH_ERROR',
  props<{ payload: any }>()
);

export const getChartCustomerDecisionPerPartProductionYear = createAction(
  '[Parts] GET_CHART_CUSTOMER_DECISION_PER_PART_PRODUCTION_YEAR',
  props<{ sources?: Array<string>, supplierNumbers?: Array<string>, partGroups?: Array<string>, returnCountries?: Array<string>, partProductionDateFrom?: string, partProductionDateTo?: string }>()
);
export const getChartCustomerDecisionPerPartProductionYearSuccess = createAction(
  '[Parts] GET_CHART_CUSTOMER_DECISION_PER_PART_PRODUCTION_YEAR_SUCCESS',
  props<{ chartData: ComplaintsModelCharts9[] }>()
);
export const getChartCustomerDecisionPerPartProductionYearError = createAction(
  '[Parts] GET_CHART_CUSTOMER_DECISION_PER_PART_PRODUCTION_YEAR_ERROR',
  props<{ payload: any }>()
);

export const getChartCustomerDecisionPerPartProductionMonth = createAction(
  '[Parts] GET_CHART_CUSTOMER_DECISION_PER_PART_PRODUCTION_MONTH',
  props<{ sources?: Array<string>, supplierNumbers?: Array<string>, partGroups?: Array<string>, returnCountries?: Array<string>, partProductionDateFrom?: string, partProductionDateTo?: string }>()
);
export const getChartCustomerDecisionPerPartProductionMonthSuccess = createAction(
  '[Parts] GET_CHART_CUSTOMER_DECISION_PER_PART_PRODUCTION_MONTH_SUCCESS',
  props<{ chartData: ComplaintsModelCharts10[] }>()
);
export const getChartCustomerDecisionPerPartProductionMonthError = createAction(
  '[Parts] GET_CHART_CUSTOMER_DECISION_PER_PART_PRODUCTION_MONTH_ERROR',
  props<{ payload: any }>()
);

export const getChartEightDNamePerPartProductionMonth = createAction(
  '[Parts] GET_CHART_EIGHT_D_NAME_PER_PART_PRODUCTION_MONTH',
  props<{ sources?: Array<string>, supplierNumbers?: Array<string>, partGroups?: Array<string>, returnCountries?: Array<string>, partProductionDateFrom?: string, partProductionDateTo?: string }>()
);
export const getChartEightDNamePerPartProductionMonthSuccess = createAction(
  '[Parts] GET_CHART_EIGHT_D_NAME_PER_PART_PRODUCTION_MONTH_SUCCESS',
  props<{ chartData: ComplaintsModelCharts11[] }>()
);
export const getChartEightDNamePerPartProductionMonthError = createAction(
  '[Parts] GET_CHART_EIGHT_D_NAME_PER_PART_PRODUCTION_MONTH_ERROR',
  props<{ payload: any }>()
);

export const getChartPartProductionYearPerSupplierNumber = createAction(
  '[Parts] GET_CHART_PART_PRODUCTION_YEAR_PER_SUPPLIER_NUMBER',
  props<{ sources?: Array<string>, supplierNumbers?: Array<string>, partGroups?: Array<string>, returnCountries?: Array<string>, partProductionDateFrom?: string, partProductionDateTo?: string }>()
);
export const getChartPartProductionYearPerSupplierNumberSuccess = createAction(
  '[Parts] GET_CHART_PART_PRODUCTION_YEAR_PER_SUPPLIER_NUMBER_SUCCESS',
  props<{ chartData: ComplaintsModelCharts12[] }>()
);
export const getChartPartProductionYearPerSupplierNumberError = createAction(
  '[Parts] GET_CHART_PART_PRODUCTION_YEAR_PER_SUPPLIER_NUMBER_ERROR',
  props<{ payload: any }>()
);

export const getChartRepairCountryPerSupplierNumber = createAction(
  '[Parts] GET_CHART_REPAIR_COUNTRY_PER_SUPPLIER_NUMBER',
  props<{ sources?: Array<string>, supplierNumbers?: Array<string>, partGroups?: Array<string>, returnCountries?: Array<string>, shipmentDateFrom?: string, shipmentDateTo?: string }>()
);
export const getChartRepairCountryPerSupplierNumberSuccess = createAction(
  '[Parts] GET_CHART_REPAIR_COUNTRY_PER_SUPPLIER_NUMBER_SUCCESS',
  props<{ chartData: ComplaintsModelCharts13[] }>()
);
export const getChartRepairCountryPerSupplierNumberError = createAction(
  '[Parts] GET_CHART_REPAIR_COUNTRY_PER_SUPPLIER_NUMBER_ERROR',
  props<{ payload: any }>()
);

export const getChartCustomerDecisionPerVehicleModel = createAction(
  '[Parts] GET_CHART_CUSTOMER_DECISION_PER_VEHICLE_MODEL',
  props<{ sources?: Array<string>, supplierNumbers?: Array<string>, partGroups?: Array<string>, returnCountries?: Array<string>, shipmentDateFrom?: string, shipmentDateTo?: string }>()
);
export const getChartCustomerDecisionPerVehicleModelSuccess = createAction(
  '[Parts] GET_CHART_CUSTOMER_DECISION_PER_VEHICLE_MODEL_SUCCESS',
  props<{ chartData: ComplaintsModelCharts14[] }>()
);
export const getChartCustomerDecisionPerVehicleModelError = createAction(
  '[Parts] GET_CHART_CUSTOMER_DECISION_PER_VEHICLE_MODEL_ERROR',
  props<{ payload: any }>()
);

export const getChartCustomerDecisionPerReturnCountry = createAction(
  '[Parts] GET_CHART_CUSTOMER_DECISION_PER_RETURN_COUNTRY',
  props<{ sources?: Array<string>, supplierNumbers?: Array<string>, partGroups?: Array<string>, returnCountries?: Array<string>, shipmentDateFrom?: string, shipmentDateTo?: string }>()
);
export const getChartCustomerDecisionPerReturnCountrySuccess = createAction(
  '[Parts] GET_CHART_CUSTOMER_DECISION_PER_RETURN_COUNTRY_SUCCESS',
  props<{ chartData: ComplaintsModelCharts15[] }>()
);
export const getChartCustomerDecisionPerReturnCountryError = createAction(
  '[Parts] GET_CHART_CUSTOMER_DECISION_PER_RETURN_COUNTRY_ERROR',
  props<{ payload: any }>()
);

export const getAllComplaintActiveErrorCodes = createAction(
  '[Parts] GET_ALL_COMPLAINT_ACTIVE_ERROR_CODES',
  props<{ source: string, supplierNumber: string }>()
);
export const getAllComplaintActiveErrorCodesSuccess = createAction(
  '[Parts] GET_ALL_COMPLAINT_ACTIVE_ERROR_CODES_SUCCESS',
  props<{ activeErrorCodes: ComplaintErrorCodeModel[] }>()
);
export const getAllComplaintActiveErrorCodesError = createAction(
  '[Parts] GET_ALL_COMPLAINT_ACTIVE_ERROR_CODES_ERROR',
  props<{ payload: any }>()
);

export const getAllActive8DNamesBySourceAndSupplierNumber = createAction(
  '[Parts] GET_ALL_ACTIVE_8D_NAMES_BY_SOURCE_AND_SUPPLIER_NUMBER',
  props<{ source: string, supplierNumber: string }>()
);
export const getAllActive8DNamesBySourceAndSupplierNumberSuccess = createAction(
  '[Parts] GET_ALl_ACTIVE_8D_NAMES_BY_SOURCE_AND_SUPPLIER_NUMBER_SUCCESS',
  props<{ rootCauses: Complaint8DNameSlimModel[] }>()
);
export const getAllActive8DNamesBySourceAndSupplierNumberError = createAction(
  '[Parts] GET_ALL_ACTIVE_8D_NAMES_BY_SOURCE_AND_SUPPLIER_ERROR',
  props<{ payload: any }>()
);

export const getDefectivePartAnalysisSupplier = createAction(
  '[Parts] GET_DEFECTIVE_PART_ANALYSIS_SUPPLIER',
  props<{ supplierNumber: string, partIdentNumber: string }>()
);
export const getDefectivePartAnalysisSupplierSuccess = createAction(
  '[Parts] GET_DEFECTIVE_PART_ANALYSIS_SUPPLIER_SUCCESS',
  props<{ defectivePartAnalysisSupplier: DefectivePartAnalysisSupplierResponseModel }>()
);
export const getDefectivePartAnalysisSupplierError = createAction(
  '[Parts] GET_DEFECTIVE_PART_ANALYSIS_SUPPLIER_ERROR',
  props<{ payload: any }>()
);

export const createErrorCode = createAction(
  '[Parts] CREATE_ERROR_CODE',
  props<{ supplierNumber: string, errorCode: string, source: string, errorLabelGerman: string, errorDescriptionGerman: string, errorLabelEnglish: string, errorDescriptionEnglish: string, errorCodeName?: string, isActive?: boolean }>()
);
export const createErrorCodeSuccess = createAction(
  '[Parts] CREATE_ERROR_CODE_SUCCESS'
);
export const createErrorCodeError = createAction(
  '[Parts] CREATE_ERROR_CODE_ERROR',
  props<{ payload: any }>()
);

export const createReferenceReport = createAction(
  '[Parts] CREATE_REFERENCE_REPORT',
  props<{ createComplaint8DNameRequest: CreateComplaint8DNameRequest, }>()
);
export const createReferenceReportSuccess = createAction(
  '[Parts] CREATE_REFERENCE_REPORT_SUCCESS'
);
export const createReferenceReportError = createAction(
  '[Parts] CREATE_REFERENCE_REPORT_ERROR',
  props<{ payload: any }>()
);

export const createDefectivePartAnalysisSupplier = createAction(
  '[Parts] CREATE_DEFECTIVE_PART_ANALYSIS_SUPPLIER',
  props<{ supplierNumber?: string, partIdentNumber?: string, source?: string, tab?: string, data?: string, files?: Blob[], ntfFiles?: Blob[], transferData?: boolean, ntfProcess?: boolean }>()
);
export const createDefectivePartAnalysisSupplierSuccess = createAction(
  '[Parts] CREATE_DEFECTIVE_PART_ANALYSIS_SUPPLIER_SUCCESS',
  props<{ defectivePartAnalysisSupplierId: number }>()
);
export const createDefectivePartAnalysisSupplierError = createAction(
  '[Parts] CREATE_DEFECTIVE_PART_ANALYSIS_SUPPLIER_ERROR',
  props<{ payload: any }>()
);

export const editDefectivePartAnalysisSupplier = createAction(
  '[Parts] EDIT_DEFECTIVE_PART_ANALYSIS_SUPPLIER',
  props<{ id: number, supplierNumber?: string, partIdentNumber?: string, source?: string, tab?: string, data?: string, files?: Blob[], ntfFiles?: Blob[], filesForDelete?: string[], transferData?: boolean, ntfProcess?: boolean }>()
);
export const editDefectivePartAnalysisSupplierSuccess = createAction(
  '[Parts] EDIT_DEFECTIVE_PART_ANALYSIS_SUPPLIER_SUCCESS'
);
export const editDefectivePartAnalysisSupplierError = createAction(
  '[Parts] EDIT_DEFECTIVE_PART_ANALYSIS_SUPPLIER_ERROR',
  props<{ payload: any }>()
);

export const downloadFile = createAction(
  '[Parts] DOWNLOAD_FILE',
  props<{ filename?: string, source?: string, partIdentNumber?: string, tab?: string }>()
);
export const downloadFileSuccess = createAction(
  '[Parts] DOWNLOAD_FILE_SUCCESS',
  props<{ file: Blob, filename: string }>()
);
export const downloadFileError = createAction(
  '[Parts] DOWNLOAD_FILE_ERROR',
  props<{ payload: any }>()
);

export const getData4D8D = createAction(
  '[Parts] GET_DATA_4D8D',
  props<{ supplierNumber: string, partIdentNumber: string }>()
);
export const getData4D8DSuccess = createAction(
  '[Parts] GET_DATA_4D8D_SUCCESS',
  props<{ data4D8D: any }>()
);
export const getData4D8DError = createAction(
  '[Parts] GET_DATA_4D8D_ERROR',
  props<{ payload: any }>()
);

export const postData4D8D = createAction(
  '[Parts] POST_DATA_4D8D',
  props<{ source: string, supplierNumber: string, partIdentNumber: string, json4D8DData: string, transferData: boolean, tab: string, files: File[] }>()
);
export const postData4D8DSuccess = createAction(
  '[Parts] POST_DATA_4D8D_SUCCESS'
);
export const postData4D8DError = createAction(
  '[Parts] POST_DATA_4D8D_ERROR',
  props<{ payload: any }>()
);

export const putData4D8D = createAction(
  '[Parts] PUT_DATA_4D8D',
  props<{ id: number, source: string, supplierNumber: string, partIdentNumber: string, json4D8DData: string, transferData: boolean, tab: string, files: File[], filesForDelete: string[] }>()
);
export const putData4D8DSuccess = createAction(
  '[Parts] PUT_DATA_4D8D_SUCCESS'
);
export const putData4D8DError = createAction(
  '[Parts] PUT_DATA_4D8D_ERROR',
  props<{ payload: any }>()
);

export const getPartAnalysisData = createAction(
  '[Parts] GET_PART_ANALYSIS_DATA',
  props<{ supplierNumber: string, partIdentNumber: string }>()
);
export const getPartAnalysisDataSuccess = createAction(
  '[Parts] GET_PART_ANALYSIS_DATA_SUCCESS',
  props<{ partAnalysisData: DataPartAnalysisResponse }>()
);
export const getPartAnalysisDataError = createAction(
  '[Parts] GET_PART_ANALYSIS_DATA_ERROR',
  props<{ payload: any }>()
);

export const editPartAnalysisData = createAction(
  '[Parts] EDIT_PART_ANALYSIS_DATA',
  props<{ source: string, tab: string, supplierNumber: string, partIdentNumber: string, partAnalysisJsonData: string, id: number, files?: Blob[], filesForDelete?: string[] }>()
);
export const editPartAnalysisDataSuccess = createAction(
  '[Parts] EDIT_PART_ANALYSIS_DATA_SUCCESS'
);
export const editPartAnalysisDataError = createAction(
  '[Parts] EDIT_PART_ANALYSIS_DATA_ERROR',
  props<{ payload: any }>()
);

export const savePartAnalysisData = createAction(
  '[Parts] SAVE_PART_ANALYSIS_DATA',
  props<{ source: string, tab: string, supplierNumber: string, partIdentNumber: string, partAnalysisJsonData: string, files?: Blob[] }>()
);
export const savePartAnalysisDataSuccess = createAction(
  '[Parts] SAVE_PART_ANALYSIS_DATA_SUCCESS'
);
export const savePartAnalysisDataError = createAction(
  '[Parts] SAVE_PART_ANALYSIS_DATA_ERROR',
  props<{ payload: any }>()
);


export const downloadPorscheFile = createAction(
  '[Parts] DOWNLOAD_PORSCHE_FILE',
  props<{ supplierNumber?: string, partIdentNumber?: string }>()
);
export const downloadPorscheFileSuccess = createAction(
  '[Parts] DOWNLOAD_PORSCHE_FILE_SUCCESS',
  props<{ file: Blob, supplierNumber: string }>()
);
export const downloadPorscheFileError = createAction(
  '[Parts] DOWNLOAD_PORSCHE_FILE_ERROR',
  props<{ payload: any }>()
);

export const getSupplierComplaintNumber = createAction(
  '[Parts] GET_SUPPLIER_COMPLAINT_NUMBER',
  props<{ source: SourceType, partIdentNumber: string }>()
);
export const getSupplierComplaintNumberSuccess = createAction(
  '[Parts] GET_SUPPLIER_COMPLAINT_NUMBER_SUCCESS',
  props<{ supplierComplaintNumber: string }>()
);
export const getSupplierComplaintNumberError = createAction(
  '[Parts] GET_SUPPLIER_COMPLAINT_NUMBER_ERROR',
  props<{ payload: any }>()
);

export const getComplaintImportHistory = createAction(
  '[Parts] GET_COMPLAINT_IMPORT_HISTORY',
  props<{ index?: number, size?: number, sortColumn?: GetImportHistorySortColumn, sortDirectionType?: SortDirectionType }>()
);
export const getComplaintImportHistorySuccess = createAction(
  '[Parts] GET_COMPLAINT_IMPORT_HISTORY_SUCCESS',
  props<{ complaintImportHistoryResponse: ImportHistoryResponse }>()
);
export const getComplaintImportHistoryError = createAction(
  '[Parts] GET_COMPLAINT_IMPORT_HISTORY_ERROR',
  props<{ payload: any }>()
);

export const getDiagnosticProtocols = createAction(
  '[Parts] GET_DIAGNOSTIC_PROTOCOLS',
  props<{ partIdentNumber: string, sourceType: SourceType }>()
);
export const getDiagnosticProtocolsSuccess = createAction(
  '[Parts] GET_DIAGNOSTIC_PROTOCOLS_SUCCESS',
  props<{ diagnosticProtocols: any[] }>()
);
export const getDiagnosticProtocolsError = createAction(
  '[Parts] GET_DIAGNOSTIC_PROTOCOLS_ERROR',
  props<{ payload: any }>()
);

export const PartsActions = {
  getAllComplaints, getAllComplaintsSuccess, getAllComplaintsError,
  getAllComplaintsByAdmin, getAllComplaintsByAdminSuccess, getAllComplaintsByAdminError,
  createComplaint, createComplaintSuccess, createComplaintError,
  getAll8dNames, getAll8dNamesSuccess, getAll8dNamesError,
  getAllPartGroups, getAllPartGroupsSuccess, getAllPartGroupsError,
  getAllSupplierComplaintNumbers, getAllSupplierComplaintNumbersSuccess, getAllSupplierComplaintNumbersError,
  getAllErrorCodes, getAllErrorCodesSuccess, getAllErrorCodesError,
  put8DName, put8DNameSuccess, put8DNameError,
  putPartGroup, putPartGroupSuccess, putPartGroupError,
  putComplaintSupplierComplaintNumber, putComplaintSupplierComplaintNumberSuccess, putComplaintSupplierComplaintNumberError,
  putErrorCode, putErrorCodeSuccess, putErrorCodeError,
  getDownloadComplaintsAsCsv, getDownloadComplaintsAsCsvSuccess, getDownloadComplaintsAsCsvError,
  getDownloadComplaintsAsExcel, getDownloadComplaintsAsExcelSuccess, getDownloadComplaintsAsExcelError,
  getAllComplaintTableFilterOptions, getAllComplaintTableFilterOptionsSuccess, getAllComplaintTableFilterOptionsError,
  getAllSources, getAllSourcesSuccess, getAllSourcesError,
  getAllComplaintChartFilterOptions, getAllComplaintChartFilterOptionsSuccess, getAllComplaintChartFilterOptionsError,
  deleteComplaint, deleteComplaintSuccess, deleteComplaintError,
  restoreComplaint, restoreComplaintSuccess, restoreComplaintError,
  postReadDataFromPorschePdf, postReadDataFromPorschePdfSuccess, postReadDataFromPorschePdfError,
  getJsonForPartIdentNumber, getJsonForPartIdentNumberSuccess, getJsonForPartIdentNumberError,
  getChartCustomerDecisionPerShipmentYear, getChartCustomerDecisionPerShipmentYearSuccess,
  getChartCustomerDecisionPerShipmentYearError, getChartCustomerDecisionPerShipmentMonth,
  getChartCustomerDecisionPerShipmentMonthSuccess, getChartCustomerDecisionPerShipmentMonthError,
  getChartSupplierFeedbackPerShipmentYear, getChartSupplierFeedbackPerShipmentYearSuccess,
  getChartSupplierFeedbackPerShipmentYearError, getChartSupplierFeedbackPerShipmentMonth,
  getChartSupplierFeedbackPerShipmentMonthSuccess, getChartSupplierFeedbackPerShipmentMonthError,
  getChartSupplierFeedbackPerRepairYear, getChartSupplierFeedbackPerRepairYearSuccess,
  getChartSupplierFeedbackPerRepairYearError, getChartSupplierFeedbackPerRepairMonth,
  getChartSupplierFeedbackPerRepairMonthSuccess, getChartSupplierFeedbackPerRepairMonthError,
  getChartSupplierFeedbackPerPartProductionYear, getChartSupplierFeedbackPerPartProductionYearSuccess,
  getChartSupplierFeedbackPerPartProductionYearError, getChartSupplierFeedbackPerPartProductionMonth,
  getChartSupplierFeedbackPerPartProductionMonthSuccess, getChartSupplierFeedbackPerPartProductionMonthError,
  getChartCustomerDecisionPerPartProductionYear, getChartCustomerDecisionPerPartProductionYearSuccess,
  getChartCustomerDecisionPerPartProductionYearError, getChartCustomerDecisionPerPartProductionMonth,
  getChartCustomerDecisionPerPartProductionMonthSuccess, getChartCustomerDecisionPerPartProductionMonthError,
  getChartEightDNamePerPartProductionMonth, getChartEightDNamePerPartProductionMonthSuccess,
  getChartEightDNamePerPartProductionMonthError, getChartPartProductionYearPerSupplierNumber,
  getChartPartProductionYearPerSupplierNumberSuccess, getChartPartProductionYearPerSupplierNumberError,
  getChartRepairCountryPerSupplierNumber, getChartRepairCountryPerSupplierNumberSuccess,
  getChartRepairCountryPerSupplierNumberError, getChartCustomerDecisionPerVehicleModel,
  getChartCustomerDecisionPerVehicleModelSuccess, getChartCustomerDecisionPerVehicleModelError,
  getChartCustomerDecisionPerReturnCountry, getChartCustomerDecisionPerReturnCountrySuccess,
  getChartCustomerDecisionPerReturnCountryError,
  getAllComplaintActiveErrorCodes, getAllComplaintActiveErrorCodesSuccess, getAllComplaintActiveErrorCodesError,
  getAllActive8DNamesBySourceAndSupplierNumber, getAllActive8DNamesBySourceAndSupplierNumberSuccess, getAllActive8DNamesBySourceAndSupplierNumberError,
  getDefectivePartAnalysisSupplier, getDefectivePartAnalysisSupplierSuccess, getDefectivePartAnalysisSupplierError,
  createErrorCode, createErrorCodeSuccess, createErrorCodeError,
  createReferenceReport, createReferenceReportSuccess, createReferenceReportError,
  createDefectivePartAnalysisSupplier, createDefectivePartAnalysisSupplierSuccess, createDefectivePartAnalysisSupplierError,
  editDefectivePartAnalysisSupplier, editDefectivePartAnalysisSupplierSuccess, editDefectivePartAnalysisSupplierError,
  downloadFile, downloadFileSuccess, downloadFileError,
  getData4D8D, getData4D8DSuccess, getData4D8DError,
  postData4D8D, postData4D8DSuccess, postData4D8DError,
  putData4D8D, putData4D8DSuccess, putData4D8DError,
  getPartAnalysisData, getPartAnalysisDataSuccess, getPartAnalysisDataError,
  editPartAnalysisData, editPartAnalysisDataSuccess, editPartAnalysisDataError,
  savePartAnalysisData, savePartAnalysisDataSuccess, savePartAnalysisDataError,
  getSupplierComplaintNumber, getSupplierComplaintNumberSuccess, getSupplierComplaintNumberError,
  downloadPorscheFile, downloadPorscheFileSuccess, downloadPorscheFileError,
  getComplaintImportHistory, getComplaintImportHistorySuccess, getComplaintImportHistoryError,
  getDiagnosticProtocols, getDiagnosticProtocolsSuccess, getDiagnosticProtocolsError
}
